import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const UpdateKyc = React.createContext({});
export let updateKycMachine: any;

const MODULE_NAME = 'machines.UpdateKyc';

export const useSMUpdateKyc = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  updateKycMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(updateKycMachine);

  return {
    updateKycMachine,
    updateKycState: state,
    updateKycSend: send,
  };
};
